export default __webpack_public_path__ + "static/media/search_icon.abed3b25.svg";